import styles from './index.less';
import { FC } from 'react';
import { Arrow } from '@react-vant/icons';
import { LeaveMessageListType } from '@/pages/ServicesMore/interface';
import { leaveMessageTypeMap } from '@/pages/ServicesMore/config';
import { useNavigate } from '@@/exports';

interface ListContainerProps {
  listDetail: LeaveMessageListType;
}

const ListContainer: FC<ListContainerProps> = (props) => {
  const { listDetail } = props;
  const navigate = useNavigate();

  const jumpToDetail = (id: string) => {
    navigate('/messageDetail', {
      state: {
        id: id,
      },
    });
  };

  return (
    <div
      className={styles.container}
      onClick={() => jumpToDetail(listDetail.sequenceNbr)}
    >
      <div className={styles.title}>
        <section>{leaveMessageTypeMap[listDetail.type]}</section>
        <Arrow />
      </div>
      <div className={styles.description}>{listDetail.content}</div>

      <div className={styles.time}>{listDetail.createTime}</div>
    </div>
  );
};

export default ListContainer;
